import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const customEase = 'cubic-bezier(.5,-0.53,.14,1.23)';

export function initGradientTitle() {
    const gradientTitles = document.querySelectorAll('.gradient:is(h1, h2, h3, h4, h5, h6, span)');

    if (gradientTitles.length === 0) {
        return;
    }

    gradientTitles.forEach(element => {
        ScrollTrigger.create({
            trigger: element,
            start: "clamp(top 80%)",
            scrub: true,
            animation: gsap.to(element, {
                backgroundPositionX: 0,
                ease: customEase
            }),
        });
    });
}

initGradientTitle();